import { convertToArrayObject } from "utils";

const initialState = {
  entities: {},
  _pagination: {
    total_records: 0,
    total_pages: 0,
    current_page: 1,
    per_page: 100,
  },
  _cache: {},
  is_fetching: false,
  active: undefined
}

const resolveEntityResponse = (response) => {
  if (!response) return response
  if (response.id || response._id) return response
  if (response.user && (response.user.id || response.user._id)) return response.user
  if (response.entity && (response.entity.id || response.entity._id)) return response.entity
  if (response.data && (response.data.id || response.data._id)) return response.data
  return response
}


export default (state = initialState, action, entity, error, parseBody) => {
  let { type, response, payload } = action;

  switch (type) {
    case `LOAD_${entity.toUpperCase()}S`: {
      let data = response
      let pagination = null
      let page = null
      let cachedAt = null
      let silent = false

      if (action.payload) {
        data = action.payload.data || []
        pagination = action.payload.pagination
        page = action.payload.page
        cachedAt = action.payload.cachedAt
        silent = action.payload.silent || false
      }

      if (!Array.isArray(data)) data = []

      if (parseBody)
        data = data.map(item => parseBody(item))

      let items = convertToArrayObject(data);
      console.log('[REDUCER LOAD] entity:', entity, 'data length:', data.length, 'silent:', silent, 'page:', page, 'pagination:', pagination)
      return {
        ...state,
        entities: silent ? state.entities : items,
        _pagination: pagination ? {
          ...pagination,
          current_page: silent ? state._pagination.current_page : pagination.current_page
        } : state._pagination,
        _cache: page != null ? {
          ...state._cache,
          [`${entity}_page_${page}`]: { cachedAt: cachedAt || Date.now() }
        } : state._cache,
        is_fetching: false
      };
    }

    case `LOAD_${entity.toUpperCase()}`: {
      response = resolveEntityResponse(response)
      if (parseBody)
        response = parseBody(response)
      let org = state.entities[response.id]

      return {
        ...state,
        is_fetching: false,
        entities: {
          ...state.entities,
          [response.id]: {
            ...org,
            ...response
          }
        }
      }
    }

    case `ADD_${entity.toUpperCase()}`: {
      response = resolveEntityResponse(response)
      const entity_id = response.id || response._id;

      if (parseBody)
        response = parseBody(response)

      return {
        ...state,
        entities: {
          ...state.entities,
          [entity_id]: {
            ...state[entity_id],
            ...response
          }
        }

      };
    }

    case `DELETE_${entity.toUpperCase()}`: {
      response = resolveEntityResponse(response)
      const entity_id = response.id || response._id;

      if (parseBody)
        response = parseBody(response)

      let newItems = {
        ...state.entities
      };

      delete newItems[entity_id];

      return {
        ...state,
        entities: newItems
      }
    }

    case `UPDATE_${entity.toUpperCase()}`: {
      response = resolveEntityResponse(response)
      const entity_id = response.id || response._id;
      
      if (!entity_id) {
        console.warn(`[UPDATE_${entity.toUpperCase()}] Response sin ID válido:`, response)
        return state
      }
      
      if (parseBody)
        response = parseBody(response)
      let org = state.entities[entity_id]

      return {
        ...state,
        entities: {
          ...state.entities,
          [entity_id]: {
            ...org,
            ...response
          }
        }
      };
    }

    case `FETCH_${entity.toUpperCase()}S`: {
      return {
        ...state,
        is_fetching: true
      };
    }

    case `INVALIDATE_${entity.toUpperCase()}S`: {
      return {
        ...initialState,
        active: state.active,
      };
    }

    case `UNLOAD_${entity.toUpperCase()}S`: {
      return {
        ...state,
        entities: {},
        _pagination: initialState._pagination,
        _cache: {},
        is_fetching: false
      };
    }

    case `SET_${entity.toUpperCase()}`: {
      return {
        ...state,
        active: payload
      };
    }

    case 'LOGOUT': {
      return initialState
    }



    default:
      return state

  }
}
